export class UrlGenerationFailed extends Error {
  constructor() {
    super('Failed to generate URL');
    this.name = 'UrlGenerationFailed';
  }
}
